import styled from '@emotion/styled';

export const PopoverContainer = styled.div``;
